export const S2A_LAST_USED_APP = 's2a-last-used-app';
